<script>
    import ReportGraphic from "../../Models/reportGraphic";
    import Assessment from '../../Models/assessmentModel';
    import Loader from '../Loader.svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';
    import {engine} from '../../lib/liquid_engine';

    export let params;

    let iframe;

    $: graphic = new ReportGraphic(params.id).store;
    $: graphic_details = $graphic?.details;

    const assessments = Assessment.getAssessmentList();

    let selected_assessment;

    function handleTab(e) {
        let textArea = e.target;

        if (e.keyCode === 9) {
            let start = textArea.selectionStart;
            let end = textArea.selectionEnd;
            textArea.value = `${textArea.value.substring(0, start)}\t${textArea.value.substring(end)}`;
            textArea.selectionStart = textArea.selectionEnd = start + 1;
            e.preventDefault();
        }
    }

    function save() {
        ReportGraphic.save(graphic_details).then(() => {
            notifier.success("Graphic Saved")
        })
    }

    function selectAssessment() {
        addFormModal({
            title: "Select Assessment",
            fields: [
                {
                    name: "assessment",
                    label: "Assessment",
                    type: "select",
                    choices: {
                        static: $assessments.map((assessment) => {
                            return {
                                label: `${assessment.name} - ${assessment.assessment_type}`,
                                value: assessment
                            }
                        })
                    }
                }
            ]
        }).then((data) => {
            let _assessment = new Assessment(data.assessment);
            selected_assessment = _assessment.getAssessmentStore();
        })
    }

    function render(template, assessment, iframe) {
        if (!(template && assessment && iframe)) {
            if (iframe) {
                if (!assessment) {
                    iframe.contentDocument.body.innerHTML = "<h1>No Assessment Selected</h1>"
                } else if (!template) {
                    iframe.contentDocument.body.innerHTML = "<h1>No Template Provided</h1>"
                }
            }

            return;
        }

        engine.parseAndRender(template, assessment).then((results) => {
            iframe.contentDocument.body.innerHTML = results;
            iframe.contentWindow.render();
        }).catch((e) => {
            return;
        })
    }

    $: render(graphic_details?.template, $selected_assessment, iframe)
</script>

<Loader loading={!$graphic}>
    <div class="container is-fluid">
        <h1 class="title is-1">
            Edit Graphic
            <a href="#/reportGraphic" class="button is-pulled-right">Close</a>
        </h1>
        <form on:submit|preventDefault={save}>
            <div class="field is-horizontal is-large">
                <div class="field-label is-narrow is-large">
                    <label class="label">Graphic Name</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input is-large" type="text" bind:value={graphic_details.name}>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-grouped">
                <div class="control">
                    <div class="field is-horizontal">
                        <div class="field-label is-narrow">
                            <label class="label inline-label">Height (px):</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="number" bind:value={graphic_details.height}>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="control">
                    <div class="field is-horizontal">
                        <div class="field-label is-narrow">
                            <label class="label inline-label">Width (px):</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="number" bind:value={graphic_details.width}>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <div class="field">
                        <label class="label">Template</label>
                        <div class="field">
                            <div class="control">
                                <textarea class="textarea" rows=20 bind:value={graphic_details.template} on:keydown={handleTab}></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="buttons is-right">
                <button class="button is-success">Save</button>
            </div>
        </form>

        <h2 class="title is-2">Preview:</h2>
        <div>
            <button class="button" on:click={selectAssessment}>Select Assessment</button>
        </div>
        {#if $selected_assessment}
            <div>
                    Current Assessment: <strong>{$selected_assessment.details.name}</strong>
            </div>
        {/if}
        <div>
            <!-- svelte-ignore a11y-missing-attribute -->
            <iframe bind:this={iframe} height="{graphic_details.height}px" width="{graphic_details.width}px" src="/graphic_preview.html"></iframe>
        </div>
    </div>
</Loader>

<style>
    .is-horizontal .label {
        line-height: 2.5em;
        padding-left: 2em;
    }

    iframe {
        border: 1px solid grey;
    }
</style>